'use strict';
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

export class IonicModal extends Component {
  static propTypes = {
    useScrollWrapper: PropTypes.bool,
    modalClass: PropTypes.string,
    animation: PropTypes.string,
  };

  static defaultProps = {
    animation: 'slide-in-up',
    // focusFirstInput: false,
    // unfocusOnHide: true,
    // focusFirstDelay: 600,
  };

  constructor(props) {
    super(props);
    this.state = {
      entered: false,
    };
  }

  componentDidMount() {
    this.animateIn = setTimeout(() => this.setState({entered: true}), 50);
    this.hasOpened = true;
  }

  componentWillUnmount() {
    clearTimeout(this.animateIn);
  }

  render() {
    return (
      <div
        className="modal-backdrop active"
        onClick={this.props.onClickBackdrop}
      >
        <div className="modal-wrapper">
          <div className={classNames(
            this.props.modalClass,
            this.props.animation,
            'modal ng-enter active', {
              'ng-enter-active': this.state.entered,
            })}
          >
            {this.renderIonicBody()}
          </div>
        </div>
      </div>
    );
  }

  renderIonicBody() {
    return this.props.useScrollWrapper ? (
      <div className="scroll-content ionic-scroll scroll-content-false">
        {this.props.children}
      </div>
    ) : (
      this.props.children
    );
  }
}

/**
 * @typedef {Object} IonicModalProps
 * @property {String} [modalClass]
 * @property {String} [animation="slide-in-up"]
 */



// WEBPACK FOOTER //
// ./src/js/core-utilities/react-modals/IonicModal.js